import Validator from 'validate-js';
import { getRules, removeErrors, showErrors } from './helpers';

const form = document.querySelector('form.js-validation, .js-validation form');

if (form) {
  var validator = new FormValidator(form, getRules(form), validatorCallback);
}

function validatorCallback(errors, event) {
  const form = this.form;

  if (!form.classList.contains('submitted')) {
    form.classList.add('submitted');

    // add validation on blur
    for (let field in this.fields) {
      this.fields[field].element.addEventListener('blur', e => {
        // removeErrors(form);
        this._validateForm(event);
        // this._validateField(this.fields[field]);
      });
    }
  }

  removeErrors(form);

  if (errors.length) {
    showErrors(form, errors);
    return;
  }

  if (typeof qmSubmitForm === 'function') {
    event.preventDefault();
    qmSubmitForm(form);
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/js/forms/validation.js
// module id = 7
// module chunks = 0